import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../store';
import {selectFamily, selectFinalized} from '../selectors';

@customElement('line-steel-label')
export class LineSteelLabel extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				z-index: 100;
			}

			.label {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				margin-inline: auto;
				width: fit-content;

				background: rgb(80 80 80);
				color: white;
				padding: 5px 10px;
				font-family: Courier New, monospace;
				font-size: 15px;
				text-align: center;
				z-index: 1000;
			}
			.link {
				color: white;
			}

		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}
	stateChanged(state) {
		this.state = state;
		this.userProfile = state.userProfile.data;
		this.status = state.status;
		this.baseUrl = state.status.baseUrl;
		this.region = state.status.region;
		this.lang = state.status.lang;
		this.datakey = state.status.dataKey;
		this.dev = !window.location.href.includes('selux.com');

		this.show = selectFamily(state) === 'TheLine' && !selectFinalized(state);
	}


	render() {
		if (!this.show) return null;
		return html`
			<div class="label">
				${msg('The steel variant will be discontinued.')}<br>
				<a class="link" href="https://www.selux.com/configuration2/${this.region}/${this.lang}/Line/sections/${this.datakey}">${msg('Configure the aluminium variant here.')}</a>
			</div>
		`;
	}
}
